import { render, staticRenderFns } from "./QuestionSelect.vue?vue&type=template&id=0dfe931e&scoped=true&"
import script from "./QuestionSelect.vue?vue&type=script&lang=js&"
export * from "./QuestionSelect.vue?vue&type=script&lang=js&"
import style0 from "./QuestionSelect.vue?vue&type=style&index=0&id=0dfe931e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfe931e",
  null
  
)

export default component.exports